/**
 * Saved Filters Mutations
 */

export default {
  SET_FILTERS(state, filters) {
    state.filters = filters
  },

  ADD_FILTER(state, filter) {
    state.filters.push(filter)
  },

  UPDATE_FILTER(state, { id, updates }) {
    const index = state.filters.findIndex((f) => f.id === id)
    if (index !== -1) {
      state.filters.splice(index, 1, { ...state.filters[index], ...updates })
    }
  },

  DELETE_FILTER(state, id) {
    state.filters = state.filters.filter((f) => f.id !== id)
  },

  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_ACTIVE_FILTER(state, id) {
    state.activeFilterId = id
  },
}
